module.exports = __webpack_public_path__ + "img/brand-star.a2252b74.png";